var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { ChangeDetectorRef, Component, EventEmitter, Input, Optional, Output, } from '@angular/core';
import { DePermissionService } from '@synisys/idm-de-service-client-js';
import { CellModel, FormType, } from '@synisys/idm-dynamic-layout-interpreter';
import { isNil, memoize, some, values } from 'lodash';
import { filter, takeUntil } from 'rxjs/operators';
import { ActionNotifierKey } from '../../concepts';
import { AbstractDestructionSubject } from '../abstract-destruction-subject';
import { DynamicLayout } from '../dynamic-layout';
import { CellStyleTemplate } from './cell.style.template.enum';
var CellComponent = /** @class */ (function (_super) {
    __extends(CellComponent, _super);
    function CellComponent(dePermissionService, cd) {
        var _this = _super.call(this) || this;
        _this.dePermissionService = dePermissionService;
        _this.cd = cd;
        _this.cellVisibility = new EventEmitter();
        _this.initialized = false;
        _this.isReady = false;
        _this._hasViewPermission = true;
        _this._isCard = false;
        return _this;
    }
    CellComponent_1 = CellComponent;
    Object.defineProperty(CellComponent.prototype, "styleBlock", {
        get: function () {
            return this._styleBlock;
        },
        set: function (value) {
            this._styleBlock = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellComponent.prototype, "title", {
        get: function () {
            return CellComponent_1.getTitle(this.cellModel);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellComponent.prototype, "isCard", {
        get: function () {
            return this._isCard;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellComponent.prototype, "hasViewPermission", {
        get: function () {
            return this._hasViewPermission;
        },
        set: function (value) {
            this._hasViewPermission = value;
            this.cellVisibility.emit(this._hasViewPermission);
        },
        enumerable: true,
        configurable: true
    });
    CellComponent.createTitle = function (cellModel) {
        return {
            titleSrc: cellModel.title.titleMessageSource,
            customText: cellModel.title.customText,
            messageId: cellModel.title.titleMessage,
            style: cellModel.properties.template === 'card'
                ? CellStyleTemplate.CARD
                : CellStyleTemplate.TRANSPARENT,
        };
    };
    CellComponent.prototype.isPage = function () {
        return this._styleBlock === 'page';
    };
    CellComponent.prototype.isForm = function () {
        return this._styleBlock === 'form';
    };
    CellComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._isCard = this.cellModel.properties.template === 'card';
        this.hasViewPermission = this.isCellVisible(this.cellModel);
        this.setIfReadonly();
        this.isReady = true;
        if (this.layout.isForm()) {
            this.layout
                .getActionNotifier()
                .pipe(filter(function (notification) {
                return notification.key ===
                    ActionNotifierKey.DO_WORKFLOW_ACTION || notification.key === ActionNotifierKey.SAVE_ACTION;
            }), takeUntil(this.destroySubject$))
                .subscribe(function () {
                _this.setIfReadonly();
                _this.cd.detectChanges();
            }, function (err) { return console.error(err); });
        }
    };
    CellComponent.prototype.ngAfterViewInit = function () {
        this.initialized = true;
        this.cd.detectChanges();
    };
    CellComponent.prototype.getControlStyle = function (control) {
        return control && control.properties.generalProperties.has('style')
            ? control.properties.generalProperties
                .get('style')['classes'].join(' ')
            : '';
    };
    CellComponent.prototype.setIfReadonly = function () {
        var _this = this;
        if (this.layout.isForm() &&
            this.cellModel.controlModel &&
            this.checkIfFieldsDefined()) {
            var generalProperties = this.cellModel.controlModel.properties
                .generalProperties;
            if (this.layout.getMetaForm().formType === FormType.EDIT && this.layout.getMetaForm().dePermission) {
                var controlFields = new Set(Object.keys(this.cellModel.controlModel.fields)
                    .map(function (key) { return _this.cellModel.controlModel.fields[key]; })
                    .map(function (field) {
                    return field ? field.metaFieldId.systemName : undefined;
                }));
                var permissibleFields = this.getPermissibleFields(controlFields);
                if (this.layout.getEntity().getInstanceId() === null &&
                    controlFields.size ===
                        permissibleFields.controlAddableFields.length) {
                    generalProperties = generalProperties.set('editable', true);
                }
                else if (controlFields.size !==
                    permissibleFields.controlEditableFields.length) {
                    generalProperties = generalProperties
                        .set('isreadonly', true)
                        .set('isReadonly', true);
                }
                else {
                    generalProperties = generalProperties.set('editable', true);
                }
            }
            else if (this.layout.getMetaForm().formType === FormType.VIEW) {
                generalProperties = generalProperties
                    .set('isreadonly', true)
                    .set('isReadonly', true)
                    .set('viewMode', true);
            }
            this.cellModel.controlModel.properties.generalProperties = generalProperties;
        }
    };
    CellComponent.prototype.checkIfFieldsDefined = function () {
        return !some(values(this.cellModel.controlModel.fields), isNil);
    };
    CellComponent.prototype.isCellVisible = function (cellModel) {
        var _this = this;
        if (this.isPage()) {
            return true;
        }
        var isGrid = function (cell) { return !!cell.grid; };
        var booleanReducer = function (sum, next) { return sum || next; };
        var getControlFields = function (control) {
            var fields = new Set();
            Object.keys(control.fields)
                .map(function (key) { return control.fields[key]; })
                .filter(function (field) {
                return field &&
                    field.metaFieldId &&
                    field.metaFieldId.systemName;
            })
                .forEach(function (field) { return fields.add(field.metaFieldId.systemName); });
            return fields;
        };
        if (isGrid(cellModel)) {
            return cellModel.grid.rows
                .map(function (row) {
                return row.cells
                    .map(function (cell) { return _this.isCellVisible(cell); })
                    .reduce(booleanReducer, false);
            })
                .reduce(booleanReducer, false);
        }
        var controlFields = getControlFields(cellModel.controlModel);
        return this.layout.getEntity().getInstanceId() === null
            ? this.getPermissibleFields(controlFields).controlAddableFields
                .length === controlFields.size
            : this.getPermissibleFields(controlFields).controlViewableFields
                .length === controlFields.size;
    };
    CellComponent.prototype.getPermissibleFields = function (controlFields) {
        var permissions = this.layout.getMetaForm().dePermission;
        return {
            controlEditableFields: !isNil(permissions)
                ? permissions.editableFields.filter(function (editableField) {
                    return controlFields.has(editableField);
                })
                : Array.from(controlFields.values()),
            controlViewableFields: !isNil(permissions)
                ? permissions.viewableFields.filter(function (viewableField) {
                    return controlFields.has(viewableField);
                })
                : Array.from(controlFields.values()),
            controlAddableFields: !isNil(permissions)
                ? permissions.addableFields.filter(function (addableField) {
                    return controlFields.has(addableField);
                })
                : Array.from(controlFields.values()),
        };
    };
    CellComponent.getTitle = memoize(CellComponent_1.createTitle);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], CellComponent.prototype, "styleBlock", null);
    __decorate([
        Input(),
        __metadata("design:type", CellModel)
    ], CellComponent.prototype, "cellModel", void 0);
    __decorate([
        Input(),
        __metadata("design:type", Number)
    ], CellComponent.prototype, "tabId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", DynamicLayout)
    ], CellComponent.prototype, "layout", void 0);
    __decorate([
        Output(),
        __metadata("design:type", EventEmitter)
    ], CellComponent.prototype, "cellVisibility", void 0);
    CellComponent = CellComponent_1 = __decorate([
        Component({
            moduleId: module.id + '',
            selector: 'cell',
            template: require('./cell.component.html'),
        }),
        __param(0, Optional()),
        __metadata("design:paramtypes", [DePermissionService,
            ChangeDetectorRef])
    ], CellComponent);
    return CellComponent;
    var CellComponent_1;
}(AbstractDestructionSubject));
export { CellComponent };
//# sourceMappingURL=cell.component.js.map